import { useEffect } from 'react'
import * as Sentry from '@sentry/tanstackstart-react'
import { createFileRoute, type ErrorComponentProps } from '@tanstack/react-router'
import { SchoolSchedulesClient } from '../components/SchoolSchedulesClient'
import { prefetchSchoolSchedules, prefetchSchoolPolicies } from '../lib/route-prefetch'

function SchoolSchedulesError({ error }: ErrorComponentProps) {
  useEffect(() => { Sentry.captureException(error) }, [error])
  return (
    <div className="p-8 text-center text-gray-600">
      Failed to load schedules.{' '}
      <button onClick={() => window.location.reload()} className="text-brand underline">
        Retry
      </button>
    </div>
  )
}

export const Route = createFileRoute('/school/$schoolId/schedules')({
  head: () => ({
    meta: [{ title: 'School Schedules | Unbreakable' }],
  }),
  beforeLoad: ({ context, params }) => {
    prefetchSchoolSchedules(context.queryClient, params.schoolId)
    prefetchSchoolPolicies(context.queryClient, params.schoolId)
  },
  errorComponent: SchoolSchedulesError,
  component: SchoolSchedulesPage,
})

function SchoolSchedulesPage() {
  return <SchoolSchedulesClient />
}
